import { LinkTypes } from 'fitify-ui-landing/src/@types'
import { createRedirectLinkWithLocale } from 'fitify-ui-landing/src/utils/link'

export const enhanceWithLocale = (
  locale: string,
  item: LinkTypes.Navigation
): LinkTypes.Navigation => {
  if (item.isOnboarding) {
    return {
      ...item,
      link: createRedirectLinkWithLocale(item.link, locale),
    }
  } else {
    return {
      ...item,
    }
  }
}
